import { useMemo } from "react";

import {
  NAV_GROUP_NAMES,
  NAV_V3_ITEMS,
} from "@/components/navigation/primary/constants";
import { PrimaryNavigationItemCollapsableWithIconI } from "@/components/navigation/primary/interfaces";
import { useFetchDialBlocksSwitch } from "@/modules/dial-blocks/data/queries";

/**
 * The "My week" entry while the backend's dial block switch is on, otherwise
 * nothing. Fails closed: loading, off (404) and any error all hide it.
 */
export const useMyWeekNavItems =
  (): Array<PrimaryNavigationItemCollapsableWithIconI> => {
    const { data: isSwitchedOn } = useFetchDialBlocksSwitch();

    return useMemo(
      () =>
        isSwitchedOn === true ? [NAV_V3_ITEMS[NAV_GROUP_NAMES.MY_WEEK]] : [],
      [isSwitchedOn]
    );
  };
